import { reactive, ref, nextTick } from 'vue'
import { renderQrCode } from '@/utils/qrcode'

export interface TipOptions {
  title: string
  content: string
  confirmText?: string
  showCancel?: boolean
  onConfirm?: () => void
}

export function useStarTip() {
  const tipDialog = reactive({
    visible: false,
    title: '',
    content: '',
    confirmText: '确认',
    showCancel: false,
    onConfirm: () => { tipDialog.visible = false }
  })

  const showQrDialog = ref(false)
  const qrContainerRef = ref<HTMLElement | null>(null)

  const showTip = (opts: TipOptions) => {
    tipDialog.title = opts.title
    tipDialog.content = opts.content
    tipDialog.confirmText = opts.confirmText || '确认'
    tipDialog.showCancel = opts.showCancel || false
    tipDialog.onConfirm = opts.onConfirm || (() => { tipDialog.visible = false })
    tipDialog.visible = true
  }

  const showUnlockQr = async () => {
    tipDialog.visible = false
    showQrDialog.value = true
    await nextTick()
    if (qrContainerRef.value) renderQrCode(qrContainerRef.value, 'https://test-s.jinyi999.cn/xpUZs7')
  }

  /**
   * 处理一键回测接口返回的 status
   * status 1: 成功，执行 onSuccess 回调
   * status 2: 名称已存在
   * status 3: 免费用户额度不足，弹解锁
   * status 4: 券商用户额度不足，弹解锁
   * status 5: 其他错误，弹 toast
   */
  const handleBacktestStatus = (
    status: number,
    toast: string | undefined,
    onSuccess: () => void
  ) => {
    if (status === 1) {
      onSuccess()
      return
    }
    if (status === 3 || status === 4) {
      const content = status === 3
        ? '成为星级用户，解锁功能权限'
        : '免费试用次数已用完，升级星级服务，解锁更多使用次数'
      showTip({ title: '温馨提示', content, confirmText: '立即解锁', showCancel: true, onConfirm: showUnlockQr })
      return
    }
    // status 2 名称已存在 / status 5 其他错误
    const content = status === 2 ? '名称已存在' : (toast || '操作失败，请稍后重试')
    showTip({ title: '温馨提示', content, confirmText: '确认', showCancel: false, onConfirm: () => { tipDialog.visible = false } })
  }

  return { tipDialog, showQrDialog, qrContainerRef, showTip, showUnlockQr, handleBacktestStatus }
}
